import { render } from "./SalesWizardChart.vue?vue&type=template&id=8860c010"
import script from "./SalesWizardChart.vue?vue&type=script&lang=js"
export * from "./SalesWizardChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__